import type { AiAgentMessage } from '../ai-agent.type'

function timeAgo(ts: number): string {
  const now = Date.now()
  const diff = now - ts
  const minutes = Math.floor(diff / 60000)
  const hours = Math.floor(diff / 3600000)
  const days = Math.floor(diff / 86400000)

  if (minutes < 1) return 'Just now'
  if (minutes < 60) return `${minutes}m ago`
  if (hours < 24) return `${hours}h ago`
  return `${days}d ago`
}

function shouldShowTimestamp(messages: AiAgentMessage[], idx: number): boolean {
  if (idx === 0) return true
  const currentMsg = messages[idx]
  const prevMsg = messages[idx - 1]
  if (!currentMsg.timestamp || !prevMsg.timestamp) return true
  return currentMsg.timestamp - prevMsg.timestamp > 60000
}

function formatTime(ts: number): string {
  const date = new Date(ts)
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

function timeAgoOrTime(ts: number): string {
  const now = Date.now()
  const diff = now - ts
  const oneDay = 24 * 60 * 60 * 1000

  if (diff < oneDay) return timeAgo(ts)
  return formatTime(ts)
}

export { timeAgo, shouldShowTimestamp, formatTime, timeAgoOrTime }

